module.exports = __webpack_public_path__ + "static/managereviews-5e10cbf94d028fc31a149053007b94f3.png";